import {
  FDBox,
  FDContentContainer, FDStack, FDTextButton,
} from '@facet-wealth/design';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

export const TaxStrategyDetailsLayout = ({
  onBack,
  backLabel,
  showBackButton,
  fixedWidth,
}) => {
  return (
    <FDContentContainer maxWidth={'lg'}>
      <FadeInBox>
        <FDStack direction={'column'} width={'100%'} spacing={2} alignItems={'center'}>
          {showBackButton
            ? (
              <FDBox width={'100%'} alignSelf={'flex-start'}>
                <FDTextButton label={backLabel} onClick={onBack} icon={'chevronLeft'} {...dataAttrs('goal-details-back-button')} />
              </FDBox>
            )
            : null
          }
          <FDStack direction={'column'} spacing={4} maxWidth="100vw">
            <FDStack direction={'column'} spacing={8}>
              <MetaControlField attr={'title'} />
              <FDStack maxWidth={800} alignSelf={'center'}>
                <MetaControlField attr={'subtitle'} />
              </FDStack>
            </FDStack>
            <MetaControlField attr={'sections'} CustomProps={{ fixedWidth }} />
          </FDStack>
        </FDStack>
      </FadeInBox>
    </FDContentContainer>
  );
};

TaxStrategyDetailsLayout.defaultProps = {
  onBack: noop,
  backLabel: 'Back',
  showBackButton: false,
};

TaxStrategyDetailsLayout.propTypes = {
  onBack: PropTypes.func,
  showBackButton: PropTypes.bool,
  backLabel: PropTypes.string,
};
